// extracted by mini-css-extract-plugin
export default {"icon":"+B5K77eavDTx9zu36QMGbg=="};